import { Account } from '../account';

type Accounts = {
  [index: number]: {
    type: number;
    name: string;
    validity: string;
  };
};
export type SentinelUser = {
  created: Date;
  givenName: string;
  familyName: string;
  email: string;
  id: string;
  organization: Organization;
  active: boolean;
  extra?: SentinelUserExtra;
};

export type DomainAccountWithDomain = {
  created: Date;
  data: DomainAccountData;
  id: string;
  userId: string;
  validTo: Date;
  domain: Domain;
  type: Account;
  domainId: number;
};

export type DomainData = {
  defaultAccountId: number;
  accounts: Accounts;
  termsUrl: string;
};

export type Domain = {
  id: number;
  name: string;
  description?: string;
  data: DomainData;
};

export type DomainAccount = {
  created: Date;
  data: DomainAccountData;
  id: string;
  userId: string;
  domainId: number;
  validTo: Date;
  type: Account;
};

interface RoleAssignmentMap {
  [key: string]: number;
}
export type RoleAssignmentGroup = {
  name: string;
  assignments: RoleAssignmentMap;
};

export type Organization = {};

export type RolesAssignment = {
  rag: number;
};

export type DomainRoleAssignment = {
  t?: Account;
  ra: RolesAssignment;
};

interface Domains {
  [key: string]: DomainRoleAssignment;
}

export type Claims = {
  aud: string;
  email: string;
  exp: number;
  family_name: string;
  given_name: string;
  jti: string;
  name: string;
  sub: string;
  did?: number;
  d?: Domains;
};

export type DomainAccountData = {
  expiry_status: string;
  followup_status: string;
  rolesAssignment: RolesAssignment;
};

type SentinelUserExtra = {
  newsletter_member_id?: string;
  newsletter_consent?: boolean;
  extAuthProviderId?: number;
  extAuthId?: string;
};

/* Server responses */

export const toInternalUser = (user: ServerSentinelUser): SentinelUser => {
  return { ...user, created: new Date(user.created) };
};

export type ServerDomainAccount = {
  created: string;
  data: DomainAccountData;
  id: string;
  domainId: number;
  userId: string;
  validTo: string;
  type: number;
};

export type ServerOrganization = {
  '@id': string;
};

export type ServerSentinelUser = {
  id: string;
  givenName: string;
  familyName: string;
  email: string;
  created: string;
  active: boolean;
  organization: ServerOrganization;
  extra: SentinelUserExtra;
};

export interface UserIdentifiable {
  userId: string;
}
